import {
    CommonButton2
} from "components/CommonUI";
import { Layout } from "components2";
import { useAdobeDigitalData } from "hooks";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { clear } from "redux/o2Appointment";
import { O2FORM } from "../constants/route";
import { useWogaa } from "hooks";

const APPT_TYPE_ID = 11;
const LOCATION_ID = 1;

export default function O2AppointmentDeleted() {
  const { endCancel: wogaaEndCancel } = useWogaa();
  const navigate = useNavigate();
  const { state: routerState } = useLocation();

  const dispatch = useDispatch();

  const { name: fullName, isLogin } = useSelector((state) => state.signPassIdentify);
  useAdobeDigitalData({name: "APPOINTMENT_DELETED", path:"/appointment-deleted"});


  useEffect(()=>{
    setTimeout(()=>wogaaEndCancel(), 1000);
    dispatch(clear());
  }, []);

  const {
    nricFin,
    passport,
  } = useSelector((state) => state.o2Appointment);

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10 mb-5"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">{isLogin && fullName ? `${fullName}, `: ""}{nricFin || passport}</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
            <div style={{ fontSize: 20, fontWeight: 400 }}>as at {moment().format("DD MMM YYYY")}</div>
          </div>
        </div>
      }>
      <div className="form-box--plain ">
        <div className={"px-1 px-sm-3 pt-3 pt-md-5"}>
          <h4 className={"mb-4 text-center"}>Your appointment has been deleted</h4>

          <div className={"elevation-1"} style={{padding: "30px 20px"}}>
          <div
            className={
              "cmp-action-card cmp-action-card--empty-state web-empty-state-card cmp-action-card--empty-state-override text-center delete-box"
            }>
            <i aria-hidden="true" className="icon-general-empty icon-illustrative" style={{zom:1.217}} ></i>
            <p>You do not have any appointments.</p>
          </div>
</div>
        </div>
        <div className={"row justify-content-center px-1 px-sm-3 pt-3 pt-md-3 lg-mb-36 xl-mb-36"}>
          <div className={"col-sm-12 col-md-6 text-center"}>
          <CommonButton2
            onClick={() => navigate(O2FORM)}
            text={
                <>
                  <div style={{display:"flex"}}>
                  Make new appointment
                  <i className={`icon-dls-add-outline`} style={{marginLeft: 8}}  aria-hidden="true"></i>
</div>
                </>
              }
            whiteOrFill={"white"}
          />
          </div>
        </div>

        <div className="form-footer">
          <div className={"w-100 d-flex flex-row-reverse px-md-3 py-2"}>
            <CommonButton2
              onClick={() =>  {
                window.location.href = window.contactUsUrl;
              }}
              text={"Back to contact us"}
              whiteOrFill={"fill"}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
